export class Footer {
  visible = true;

  static fromOther(other: Footer): Footer {
    return Object.assign(new Footer(), other);
  }
}
